import { omit } from 'lodash'

export const objectOmitProperties = omit
